import React from 'react'

import { useTranslation } from 'react-i18next'

import JanHenrikKreuzer from '../assets/JanHenrikKreuzer.jpg'
import MiriamMillen from '../assets/MiriamMillen.jpg'
import SamanthaWeiler from '../assets/SamanthaWeiler.jpg'
import SusannaKoester from '../assets/SusannaKoester.jpg'
import TeamPicture from '../assets/team.jpg'
import { formatBreakline } from '../utils/HTML-breakline-converter'

interface TeamProps {
    className?: string
}

export const Team: React.FC<TeamProps> = ({ className }) => {
    const { t } = useTranslation()
    const teamMembers = [
        {
            image: JanHenrikKreuzer,
            name: t('team.members.member1.name'),
            role: t('team.members.member1.role'),
            qualification: t('team.members.member1.description'),
        },
        {
            image: MiriamMillen,
            name: t('team.members.member2.name'),
            role: t('team.members.member2.role'),
            qualification: t('team.members.member2.description'),
        },
        {
            image: SusannaKoester,
            name: t('team.members.member3.name'),
            role: t('team.members.member3.role'),
            qualification: t('team.members.member3.description'),
        },
        {
            image: SamanthaWeiler,
            name: t('team.members.member4.name'),
            role: t('team.members.member4.role'),
            qualification: t('team.members.member4.description'),
        },
    ]

    return (
        <div className="w-full flex flex-col justify-center items-center">
            <div className={`${className} w-full bg-white h-auto flex flex-col justify-center items-center`}>
                <div className="w-full h-auto flex items-start">
                    <img src={TeamPicture} alt="Team" className="w-full h-full object-cover sm:object-contain" />
                </div>
                <h1 className="text-4xl font-bold w-full justify-start text-primary-green py-20 px-3">
                    — &nbsp;{t('team.title')}
                </h1>
                <div
                    className="h-auto grid grid-cols-3 justify-center gap-x-24 gap-y-8 w-full max-w-6xl px-3
                    xs:grid-cols-1 sm:grid-cols-2 sm:gap-x-14 xl:px-0
                ">
                    {teamMembers.map((member, index) => (
                        <div key={index} className="flex flex-col pb-20">
                            <div className="flex flex-col w-full h-96 justify-end relative">
                                <img
                                    src={member.image}
                                    alt={member.name}
                                    className="w-full h-full absolute object-cover object-top"
                                    style={{ objectPosition: 'center 40%' }}
                                />
                                <div className="bg-opacity-80 z-10 h-22 bg-primary-green text-white">
                                    <h2 className="text-lg font-semibold mx-3 my-1">{member.name}</h2>
                                    <p dangerouslySetInnerHTML={{ __html: formatBreakline(member.role) }} className="mx-3 my-2" />
                                </div>
                            </div>
                            <div>
                                <p
                                    dangerouslySetInnerHTML={{ __html: formatBreakline(member.qualification) }}
                                    className="pt-3 text-primary-green px-3"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
